<template>
  <div>
    <div class="postPreview">
      <div class="post">
        <div class="d-flex justify-content-between">
          <div>
            <span class="userFullName">
              <template v-if="currentPage.name">
                {{ currentPage.name }}
              </template>
              <template v-else>
                {{ getPosterTrans('face_user') }}
              </template>
            </span>
            <p class="text-muted mx-1">
              {{ getPosterTrans("now") }} ·
            </p>
          </div>
          <img
            :src="currentPage.profile?currentPage.profile:'@/assets/images/fb-avatar.jpg'"
            width="32"
            height="32"
            onerror="this.src='@/assets/images/fb-avatar.jpg'"
            style="vertical-align:middle;"
          >
        </div>
        <div class="post">
          <p
            class="message"
            :class="(form.message.length<=130 && form.fb_preset_id!==0)?'fbpb fbpb-'+form.fb_preset_id:''"
          >
            <template v-if="form.message===''">
              <span
                class="defaultMessage"
                style="width: 60%"
              />
              <span
                class="defaultMessage"
                style="width: 80%"
              />
              <span
                class="defaultMessage"
                style="width: 50%"
              />
            </template>
            <template v-else>
              <span
                style="white-space: pre;"
                v-html="form.message"
              />
            </template>
          </p>
        </div>
        <div
          v-if="form.files.length"
          class="previewImageType"
          :class="(form.files.length<5)?'pit'+(form.files.length-1):'pit4'"
        >
          <template v-for="(image,index) in form.files">
            <div
              v-if="image.url && index<4"
              :key="'image'+index"
              :class="'image_'+(index+1)"
            >
              <div
                v-if="index===3 && form.files.length>4"
                class="moreImages"
              >
                + {{ form.files.length-4 }}
              </div>
              <img
                :id="'img-sel'+index"
                class="img-sel"
                :src="image.url"
              >
            </div>
          </template>
          <template v-for="(image,index) in form.files">
            <div
              v-if="image.url && index>=4"
              :key="'image'+index"
            >
              <img
                :id="'img-sel'+index"
                class="img-sel"
                style="display: none"
                :src="image.url"
              >
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PosterPreview',
  computed: {
    ...mapGetters({
      form: 'poster/form',
      images: 'poster/images',
      currentPage: 'pages/currentPage',
    }),
  },
  methods: {
    getPosterTrans(str) {
      return this.$t(`poster.${str}`)
    },
  },
}
</script>
